module.exports = __webpack_public_path__ + "images/backgrounds/river/medium.67c2c39a74a32f383ffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/river/medium.jpg
// module id = Jsf+
// module chunks = 24